import { ReactNode } from 'react'
import { CopyLink, LoadingIndicator } from '@/shared/ui'

export type LinkCellProps = {
    link?: string
    children?: ReactNode
}
export const LinkCell = ({ link, children }: LinkCellProps) => {
    return (
        <>
            {link ? (
                <div className="flex w-full items-center pl-2">
                    <div className="truncate text-[var(--blue-primary)]">
                        <CopyLink text={link} className="text-[12px]" />
                    </div>
                    {children}
                </div>
            ) : (
                <div className="flex justify-center">
                    <LoadingIndicator
                        style={{
                            width: '20px',
                            height: '20px',
                            marginRight: '0.5em',
                        }}
                    />
                </div>
            )}
        </>
    )
}
